import { CSSProperties } from 'react';
import styled from 'styled-components';

import defaultBackground from './assets/default.jpg';
import goldenBackground from './assets/golden.jpg';

const Root = styled.div`
  --bg-url: url(${defaultBackground});
  position: absolute;
  inset: 0;
  background: var(--bg-url) no-repeat center center;
  background-size: cover;
  z-index: 0;
`;

type Props = {
  golden?: boolean;
};
export const Background = ({ golden }: Props) => {
  return (
    <Root
      style={
        {
          '--bg-url': `url(${golden ? goldenBackground : defaultBackground})`,
        } as CSSProperties
      }
    />
  );
};
